import ReactDOM from "react-dom";
import { OwcBackdrop, OwcProgressSpinner } from "@one/react";
import { BACKDROP_ZINDEX } from "../../constants";

const BackdropPortal = ({
  show,
  opacity = 0.3,
  zIndex = BACKDROP_ZINDEX,
  spinnerSize = "medium",
  children
}) => {
  if (!show) return null;

  const backdropContent = (
    <OwcBackdrop opacity={opacity} style={{ zIndex }}>
      {children || <OwcProgressSpinner size={spinnerSize} />}
    </OwcBackdrop>
  );

  return ReactDOM.createPortal(backdropContent, document.body);
};

export default BackdropPortal;
